import { t } from './i18n/lingua.js';
/**
 * I valori tecnici che arrivano dal database, scritti come li direbbe una
 * persona.
 *
 * Nel v2 questi tipi si vedono così come sono — `main`, `office`, `other` —
 * perché erano nati per il programma, non per chi legge. Il valore resta
 * quello a database (lo usano gli import e le integrazioni): cambia solo come
 * si mostra.
 */

const TIPI_RECAPITO: Record<string, string> = {
  main: 'Principale',
  office: 'Ufficio',
  home: 'Abitazione',
  mobile: 'Cellulare',
  fax: 'Fax',
  other: 'Altro',
};

export function etichettaTipoRecapito(kind: string | null | undefined): string {
  if (!kind) return '';
  return TIPI_RECAPITO[kind] ?? kind;
}

/** Le scelte per i menu: valore tecnico dentro, italiano fuori. */
export function tipiRecapito(chiavi: readonly string[]): { valore: string; etichetta: string }[] {
  return chiavi.map((c) => ({ valore: c, etichetta: etichettaTipoRecapito(c) }));
}

const LIVELLI_ACCESSO: Record<string, string> = {
  none: t('Nessun accesso'),
  administrator: 'Amministratore',
  manager: 'Responsabile',
  exportmanager: 'Responsabile export',
  salesman: 'Commerciale',
  agent: 'Agente',
  accountant: t('Contabilità'),
  quality: t('Qualità'),
  hrmanager: t('Responsabile del personale'),
  production: t('Produzione'),
};

export function etichettaLivello(livello: string | null | undefined): string {
  if (!livello) return '';
  return LIVELLI_ACCESSO[livello] ?? livello;
}

const TIPI_ANAGRAFICA: Record<string, string> = {
  customer: 'Cliente',
  supplier: 'Fornitore',
  agent: 'Agente',
  lead: 'Lead',
  prospect: 'Prospect',
  operator: 'Operatore',
};

export function etichettaTipoAnagrafica(tipo: string | null | undefined): string {
  if (!tipo) return '';
  return TIPI_ANAGRAFICA[tipo] ?? tipo;
}
